<template>
  <div class="consignor-list">
    <v-data-table
      :headers="headers"
      :items="adminConsignorList"
      sort-by="id"
      :sort-desc="true"
      :loading="tableLoader"
      loading-text="Fetching Cosignors..."
      class="mb-12 elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Consignors</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Create Asset Modal -->
          <v-dialog
            v-model="dialog"
            max-width="750px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                @click="clearConsignor"
              >
                New Consignor
              </v-btn>
            </template>
            <ConsignorForm
              v-on:dialogClose="dialog = false"
            ></ConsignorForm>
          </v-dialog>

          <!-- Edit Consignor Modal -->
          <v-dialog
            v-model="editDialog"
            max-width="750px"
          >
            <ConsignorForm
              v-on:dialogClose="editDialog = false"
            ></ConsignorForm>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- Consignor Image -->
      <template v-slot:item.imageUrl="{item}">
        <v-img 
          width=100 
          :src="item.imageUrl"
          class="my-3"
        ></v-img>
      </template>

      <!-- Consignor Link on Name -->
      <template v-slot:item.name="{item}">
        <router-link :to="`/consignor/${item.id}`">
          {{ item.name }}
        </router-link>
      </template>

      <!-- Actions -->
      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          @click="editConsignor(item.id)"
        >
          mdi-pencil
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import ConsignorForm from './ConsignorForm'

  export default {
    name: 'ConsignorList',

    components: {
      ConsignorForm
    },

    data: () => ({
      tableLoader: true,

      // Dialog show/hide
      dialog: false,
      editDialog: false,

      // Mapping datatable.
      headers: [
        {
          text: 'ID',
          value: 'id',
          align: 'start'
        },
        {
          text: 'image',
          value: 'imageUrl'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Manager',
          value: 'manager.emailAddress',
          sortable: true
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          sortable: false
        }
      ]
    }),

    methods: {
      ...mapActions([
        'getConsignors',
        'setConsignorById',
        'clearConsignor'
      ]),


      editConsignor: function (editConsignorId) {
        // Set this consignor in state for the form.
        this.setConsignorById(editConsignorId)

        // Open the dialogue.
        this.editDialog = true
      }
    },

    computed: {
      ...mapGetters([
        'adminConsignorList'
      ])
    },

    created() {
      this.getConsignors().then(() => {
        this.tableLoader = false
      })
    }
  }
</script>
